<template>
    <div
        v-if="!isLaunchMessageHidden"
        class="px-21 py-21 flex w-full flex-row gap-2 rounded bg-ds-green-100 p-5"
    >
        <font-awesome-icon
            class="text-[28px]"
            icon="fa-regular fa-address-card"
        />
        <div class="flex-1">
            These results empower agents to make a more informed decision regarding the client being verified.
        </div>
        <font-awesome-icon
            class="text-[22px] opacity-50"
            icon="fa-solid fa-xmark"
            @click="hideLaunchMessage = 'true'"
        />
    </div>
</template>

<script lang="ts" setup>
import { useLocalStorage } from '@vueuse/core';
import { computed } from 'vue';

const hideLaunchMessage = useLocalStorage('idv-report-launch-message-hidden', 'false');
const isLaunchMessageHidden = computed(() => hideLaunchMessage.value === 'true');
</script>
